import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../features/auth/authSlice";
import taskReducer from "../features/tasks/taskSlice";
import departmentReducer from "../features/departments/departmentSlice";
import employeeReducer from "../features/employees/employeeSlice";
import projectReducer from "../features/projects/projectSlice";
import groupReducer from "../features/groups/groupSlice";

const transientStateTransform = createTransform(
    (inboundState, key) => inboundState,
    (outboundState, key) => {
        if (key === "auth" || key === "tasks" || key === "departments" || key === "employees" || key === "projects" || key === "groups") {
            return {
                ...outboundState,
                loading: false,
                error: null,
            };
        }
        return outboundState;
    }
);

const persistConfig = {
    key: "root",
    storage,
    // Only persist auth state. All data slices (employees, projects, groups,
    // departments, tasks) are intentionally excluded so they always re-fetch
    // fresh data from the API — preventing stale-cache bugs.
    whitelist: ["auth"],
    transforms: [transientStateTransform],
};

const reducer = combineReducers({
    auth: authReducer,
    tasks: taskReducer,
    departments: departmentReducer,
    employees: employeeReducer,
    projects: projectReducer,
    groups: groupReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                immutableCheck: false,
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "persist/REGISTER",
                ],
            },
        }),
});

export const persistor = persistStore(store);
